var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 14,
    viewBox: "0 0 5 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.824219 11.5938C0.824219 11.1562 0.972656 10.7891 1.26953 10.4922C1.56641 10.1875 1.96875 10.0352 2.47656 10.0352C2.99219 10.0352 3.39453 10.1875 3.68359 10.4922C3.98047 10.7891 4.12891 11.1562 4.12891 11.5938C4.12891 12.0312 3.98047 12.3984 3.68359 12.6953C3.39453 12.9922 2.99219 13.1406 2.47656 13.1406C1.96875 13.1406 1.56641 12.9922 1.26953 12.6953C0.972656 12.3984 0.824219 12.0312 0.824219 11.5938ZM0.835938 1.60938C0.835938 1.17188 0.984375 0.804688 1.28125 0.507812C1.57812 0.203125 1.98047 0.0507812 2.48828 0.0507812C3.00391 0.0507812 3.40625 0.203125 3.69531 0.507812C3.99219 0.804688 4.14062 1.17188 4.14062 1.60938C4.14062 2.04688 3.99219 2.41406 3.69531 2.71094C3.40625 3.00781 3.00391 3.15625 2.48828 3.15625C1.98047 3.15625 1.57812 3.00781 1.28125 2.71094C0.984375 2.41406 0.835938 2.04688 0.835938 1.60938Z",
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColon);
export default __webpack_public_path__ + "static/media/colon.62e0c585fddecc9944a480f480fb7f51.svg";
export { ForwardRef as ReactComponent };